import React from "react";

import { formatImageAlt } from "../../../shared/utils/stringUtilities";

import "./cardConversationSlider.scss";

interface CardConversationSliderInter {
  conversation: any;
  gtmClass: string;
}

const CardConversationSlider = (props: CardConversationSliderInter) => {
  const { conversation } = props;

  return (
    <a href={conversation.info.redireccionBoton}>
      <div className="a-card-conversation-slider">
        <div className="a-card-conversation-slider__img">
          <img
            src={conversation.imagenPrincipal[0].file.url}
            alt={formatImageAlt(conversation.imagenPrincipal[0].title)}
          />
        </div>

        <p className="a-card-conversation-slider__title">
          {conversation.title || ""}
        </p>
      </div>
    </a>
  );
};

export default CardConversationSlider;
